import { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { magicRequest, magicRequestAccess } from "@/lib/api";

const NEUTRAL = "If that email is registered, a link is on its way.";

// "Field staff: email me a login link" — the second login option.
// Every outcome shows the same neutral copy (no enumeration). Only the
// JumpCloud-collision case adds "Please sign in with JumpCloud."
export default function FieldLoginOption({ requestToJoin }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mode, setMode] = useState("link"); // link | join
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "join") {
        const { data } = await magicRequestAccess({ name: name.trim(), email: email.trim().toLowerCase() });
        setMsg(data.message);
      } else {
        const { data } = await magicRequest(email.trim().toLowerCase());
        setMsg(data.use_jumpcloud ? "Please sign in with JumpCloud." : (data.message || NEUTRAL));
      }
    } catch {
      setMsg(NEUTRAL);
    } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <Button type="button" variant="outline" onClick={() => setOpen(true)} className="w-full h-11 text-[13px] font-medium rounded-lg border-slate-300" data-testid="btn-login-field">
        <span className="flex items-center justify-center gap-2"><Mail className="w-4 h-4" /> Field staff: email me a login link</span>
      </Button>
    );
  }
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="field-login-option">
      {msg ? (
        <p className="text-sm text-slate-700 text-center py-2" data-testid="field-login-message">{msg}</p>
      ) : (
        <form onSubmit={submit} className="space-y-2">
          {mode === "join" && <Input required placeholder="Your name" value={name} onChange={(e) => setName(e.target.value)} data-testid="field-join-name" />}
          <Input type="email" required placeholder="you@company.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="field-login-email-input" />
          <Button type="submit" disabled={busy || !email} className="w-full h-10 bg-slate-900 hover:bg-slate-800" data-testid="field-login-submit">
            {mode === "join" ? "Request access" : "Email me a login link"} <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
          <p className="text-[11px] text-slate-500 text-center">Links work once and expire after 15 minutes.</p>
          {requestToJoin && mode === "link" && (
            <button type="button" className="w-full text-[11px] text-slate-600 underline" onClick={() => setMode("join")} data-testid="field-join-toggle">Not registered yet? Request access</button>
          )}
        </form>
      )}
    </div>
  );
}
